import { css } from 'styled-components'
import { pointerQuery } from './dimensions'

// iOS Safari zooms the whole page in whenever a focused text field renders below 16px, and it does
// not zoom back out when the field blurs — so one tap into a 14px input leaves the app stuck
// magnified for the rest of the session. The cure is the cause, not `maximum-scale=1`: give fields
// at least 16px on touch devices and Safari has no reason to zoom.
//
// This is the floor for the *small* sizes only. Compose it after a size token that is under 16px;
// applied to a larger one it would shrink the text rather than raise it. `(hover: none)` rather than
// a width breakpoint because the behaviour belongs to the input device, not the viewport: a narrow
// desktop window has a mouse and never does this, a tablet in landscape has neither and always does.
export const touchFieldFloor = css`
    ${pointerQuery.noHover} {
        font-size: 16px;
        line-height: 24px;
    }
`

export const fontFamily = {
    sans: '"Geist", system-ui, -apple-system, "Segoe UI", sans-serif',
    mono: '"Geist Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
}

export const bold = css`
    font-weight: 500;
`

export const display = {
    large: css`
        font-size: 57px;
        line-height: 64px;
        font-weight: 400;
        letter-spacing: 0px;
    `,
    medium: css`
        font-size: 45px;
        line-height: 52px;
        font-weight: 400;
        letter-spacing: 0px;
    `,
    small: css`
        font-size: 36px;
        line-height: 44px;
        font-weight: 400;
        letter-spacing: 0px;
    `,
}

export const headline = {
    large: css`
        font-size: 32px;
        line-height: 40px;
        font-weight: 400;
        letter-spacing: 0px;
    `,
    medium: css`
        font-size: 28px;
        line-height: 36px;
        font-weight: 400;
        letter-spacing: 0px;
    `,
    small: css`
        font-size: 24px;
        line-height: 32px;
        font-weight: 400;
        letter-spacing: 0px;
    `,
}

// One ramp for both styling systems: these match the Tailwind fontSize scale in tailwind.config.js
// (13px body, a small set of steps, emphasis through weight, no positive tracking). The token names
// stay as they were so every call site picks the new values up without changes.
export const title = {
    large: css`
        font-size: 17px;
        line-height: 22px;
        font-weight: 600;
        letter-spacing: 0;
    `,
    appHeader: css`
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        letter-spacing: -0.015em;
    `,
    medium: css`
        font-size: 15px;
        line-height: 20px;
        font-weight: 600;
        letter-spacing: -0.01em;
    `,
    small: css`
        font-size: 13px;
        line-height: 18px;
        font-weight: 600;
        letter-spacing: 0;
    `,
}

export const body = {
    large: css`
        font-size: 13px;
        line-height: 19px;
        font-weight: 400;
        letter-spacing: 0;
    `,
    medium: css`
        font-size: 13px;
        line-height: 19px;
        font-weight: 400;
        letter-spacing: 0;
    `,
    small: css`
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
        letter-spacing: 0;
    `,
}

export const label = {
    large: css`
        font-size: 13px;
        line-height: 18px;
        font-weight: 500;
        letter-spacing: 0;
    `,
    medium: css`
        font-size: 12px;
        line-height: 16px;
        font-weight: 500;
        letter-spacing: 0;
    `,
    small: css`
        font-size: 11px;
        line-height: 14px;
        font-weight: 500;
        letter-spacing: 0;
    `,
}
